import { useState, useCallback, useRef } from 'react';

const useAsyncOptions = (loadOptions, watch) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const initialFetchRef = useRef(false);
    
    const fetchOptions = useCallback(async (searchValue) => {
        try {
            setLoading(true);
            const response = await loadOptions(searchValue, watch?.());
            setOptions(response || []);
        } catch (error) {
            console.error("Error fetching options:", error);
            setOptions([]);
        } finally {
            setLoading(false);
        }
    }, [loadOptions, watch]);

    const initialFetch = useCallback(async () => {
        if (initialFetchRef.current) return;
        initialFetchRef.current = true;
        await fetchOptions("");
    }, [fetchOptions]);

    return {
        options,
        loading,
        fetchOptions,
        initialFetch
    };
};

export default useAsyncOptions;